module.exports = __webpack_public_path__ + "img/整体选择.0a17f380.svg";